module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="filter-popup__input">\n	<div class="filter-map js-filter-map" id="filter-location-map"></div>\n	<select class="form-control js-radius-select" name="radius">\n    <option value="100">100 m</option>\n    <option value="250">250 m</option>\n    <option value="500">500 m</option>\n    <option value="1000" selected>1 Km</option>\n    <option value="5000">5 Km</option>\n    <option value="10000">10 Km</option>\n    <option value="25000">25 Km</option>\n    <option value="50000">50 Km</option>\n	</select>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/devices-filter/templates/filter-location.html
// module id = 403
// module chunks = 0